"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Alert", {
    enumerable: true,
    get: function() {
        return Alert;
    }
});
var _anatomy = require("@chakra-ui/anatomy");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var containerStatusesColors = {
    success: {
        backgroundColor: "background-success",
        borderStartColor: "alert-success-default"
    },
    error: {
        backgroundColor: "background-error",
        borderStartColor: "alert-error-default"
    },
    warning: {
        backgroundColor: "background-warning",
        borderStartColor: "alert-warning-default"
    },
    info: {
        backgroundColor: "background-inform",
        borderStartColor: "alert-inform-default"
    }
};
var containerVariantsColors = {
    solid: {
        success: {
            backgroundColor: "alert-success-default"
        },
        error: {
            backgroundColor: "alert-error-default"
        },
        warning: {
            backgroundColor: "alert-warning-default"
        },
        info: {
            backgroundColor: "alert-inform-default"
        }
    },
    subtle: containerStatusesColors,
    "left-accent": containerStatusesColors
};
var variantSolid = function(props) {
    var _containerVariantsColors_variant;
    var status = props.status, variant = props.variant;
    return {
        container: _object_spread({}, (_containerVariantsColors_variant = containerVariantsColors[variant]) === null || _containerVariantsColors_variant === void 0 ? void 0 : _containerVariantsColors_variant[status]),
        title: {
            color: "text-light"
        },
        description: {
            color: "text-light"
        },
        icon: {
            status: {
                success: {
                    color: "text-light"
                },
                warning: {
                    color: "text-light"
                },
                error: {
                    color: "text-light"
                },
                info: {
                    color: "text-light"
                }
            }
        }
    };
};
var generateVariantByStatus = function(props) {
    var _containerVariantsColors_variant;
    var status = props.status, variant = props.variant;
    return {
        container: _object_spread({}, (_containerVariantsColors_variant = containerVariantsColors[variant]) === null || _containerVariantsColors_variant === void 0 ? void 0 : _containerVariantsColors_variant[status], variant === "left-accent" && {
            pr: "0.5rem"
        })
    };
};
var Alert = {
    parts: _anatomy.alertAnatomy.keys,
    baseStyle: function(param) {
        var theme = param.theme;
        return {
            container: {
                borderRadius: "0.375rem",
                py: "0.75rem",
                px: "1rem"
            },
            icon: _object_spread_props(_object_spread({}, theme.components.Icon.sizes.l), {
                alignSelf: "flex-start",
                marginInlineEnd: "0.625rem",
                status: {
                    success: {
                        color: "alert-success-default"
                    },
                    warning: {
                        color: "alert-warning-default"
                    },
                    error: {
                        color: "alert-error-default"
                    },
                    info: {
                        color: "alert-inform-default"
                    }
                }
            }),
            title: {
                textStyle: "text-body-bold",
                marginInlineEnd: "0"
            },
            description: {
                textStyle: "text-body-regular"
            }
        };
    },
    defaultProps: {
        variant: "solid"
    },
    variants: {
        solid: variantSolid,
        subtle: generateVariantByStatus,
        "left-accent": generateVariantByStatus
    }
};
